<template>
    <nav class="fl-y fl-a-c md-fl-x md-fl-te-c" :class="containerClasses">
        <div :class="{'page-item':true}" class="mb-4 mb-md-0">
            <!--            <btn :design="prevNextButtonDesign" hover-shadow="9" :class="prevNextButtonClasses" class="pagination-design-2-prev-btn" @click.prevent="loadPage(1)">-->
            <btn :disabled="isOnFirstPage" :design="prevNextButtonDesign" hover-shadow="9"
                 :class="prevNextButtonClasses" class="pagination-design-2-prev-btn" @click.prevent="loadPage('prev')">
                <slot name="prev-button-inner-elems">
                    <div class="fl-x fl-a-c fl-j-sa">
                        <img src="../assets/images/icons/pagination/pagination-design-2/arrow-left.svg" alt="">
                        <div class="ml-1">Previous</div>
                    </div>
                </slot>
            </btn>
        </div>

        <ul class="pagination justify-content-center pagination-sm">
            <!--    Prev Page Button-->
            <!--            <li :class="{'disabled': isOnFirstPage,'page-item':true}">-->
            <!--                <btn design="basic-f" size="sm" class="mr-2" href="javascript:;" @click.prevent="loadPage('prev')">-->
            <!--                    <span><i :class="prevIcon"/></span>-->
            <!--                </btn>-->
            <!--            </li>-->
            <template v-if="notEnoughPages">
                <!--                <li v-for="n in totalPage" :class="className(n)" :key="n">-->
                <li v-for="n in totalPage" :key="n">
                    <btn v-if="isCurrentPage(n)" size="sm" class="mx-1" href="javascript:;" color="primary"
                         @click.prevent="loadPage(n)" v-html="n"></btn>
                    <btn v-else class="mx-1" size="sm" href="javascript:;" color="primary" design="basic-f"
                         @click.prevent="loadPage(n)" v-html="n"></btn>
                </li>
            </template>
            <template v-else>
                <li v-for="n in windowSize" :key="n">
                    <btn v-if="isCurrentPage(windowStart+n-1)" size="sm" class="mx-1" href="javascript:;"
                         color="primary" @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1"></btn>
                    <btn v-else class="mx-1" size="sm" href="javascript:;" color="primary" design="basic-f"
                         @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1"></btn>
                    <!--                    <a class="page-link p-2" href="javascript:;" @click.prevent="loadPage(windowStart+n-1)" v-html="windowStart+n-1"></a>-->
                </li>
            </template>
            <!--            Next Page Button-->
            <!--            <li :class="{'disabled': isOnLastPage,'page-item':true}">-->
            <!--                <btn design="basic-f" size="sm" class="" href="javascript:;" @click.prevent="loadPage('next')">-->
            <!--                    <span><i :class="nextIcon"/></span>-->
            <!--                </btn>-->
            <!--            </li>-->
        </ul>
        <div :class="{'page-item':true}" class="mt-4 mt-md-0">
            <!--            <btn :design="prevNextButtonDesign" hover-shadow="9" :class="prevNextButtonClasses" class="pagination-design-2-prev-btn" @click.prevent="loadPage(totalPage)">-->
            <btn :disabled="isOnLastPage" :design="prevNextButtonDesign" hover-shadow="9" :class="prevNextButtonClasses"
                 class="pagination-design-2-prev-btn" @click.prevent="loadPage('next')">
                <slot name="next-button-inner-elems">
                    <div class="fl-x fl-a-c fl-j-sa">
                        <div class="mr-2">Next</div>
                        <img src="../assets/images/icons/pagination/pagination-design-2/arrow-right.svg" alt="">
                    </div>
                </slot>
            </btn>
        </div>
    </nav>
</template>

<script>
import VueTablePaginationMixin from 'vuetable-2/src/components/VuetablePaginationMixin';
// import config from '../Config';

export default {
    name  : 'VueTablePagination2',
    props : {
        nextIcon              : { type : String /* default: config.config.tables.nextPageIcon */ },
        prevIcon              : { type : String /* default: config.config.tables.prevPageIcon */ },
        firstIcon             : { type : String /* default: config.config.tables.prevPageIcon */ },
        lastIcon              : { type : String /* default: config.config.tables.prevPageIcon */ },
        activeShadow          : { type : String, default : '11' },
        prevNextButtonDesign  : { type : String, default : 'basic-f' },
        prevNextButtonClasses : { type : [String, Array], default : '' },
        containerClasses      : { type : [String, Array], default : '' }
    },
    methods : {
        className (i) {
            const names = ['page-item'];
            if (this.isCurrentPage(i)) {
                names.push('active');
                if (this.activeShadow) {
                    names.push('bs-' + this.activeShadow);
                }
            }

            return names;
        }
    },
    mixins : [VueTablePaginationMixin]
};
</script>

<style scoped>

</style>
